<template>
  <div>
    <!-- <left-menu-admin menuActive="0" :sessionData="session"></left-menu-admin> -->
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
          <v-col cols="6" class="text-left">
            <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
          </v-col>
        </v-row>
        <!-- data table -->
        <v-row>
          <v-col cols="12">
            <v-card>
              <v-tabs v-model="tab" background-color="#1B437C" dark>
                <v-tab>
                  สถิติการได้ coin
                </v-tab>
              </v-tabs>

              <v-tabs-items v-model="tab">
                <v-tab-item>
                  <v-card flat>
                    <v-card-text>
                      <v-data-table
                        :headers="columns1"
                        :items="dataItem1"
                        :items-per-page="10"
                        dense
                      >
                        <template v-slot:[`item.CREATE_DATE`]="{ item }">
                          {{ thaiFormattedDate(item.CREATE_DATE) }}
                        </template>
                      </v-data-table>
                    </v-card-text>
                  </v-card>
                </v-tab-item>
              </v-tabs-items>
            </v-card>
            <div v-if="!dataReady" class="text-center">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>
          </v-col>
        </v-row>
        <!-- end data table -->
      </div>
    </v-main>
  </div>
</template>
<script>
// import { QrcodeStream } from 'vue-qrcode-reader'
import VuetifyMoney from '../VuetifyMoney.vue'
import axios from 'axios' // api
import adminLeftMenu from '../Sidebar.vue' // เมนู
import QrcodeVue from 'qrcode.vue'
// import JsonExcel from 'vue-json-excel' // https://www.npmjs.com/package/vue-json-excel
// import XLSX from 'xlsx' // import xlsx
// import readXlsxFile from 'read-excel-file'
// import moment from 'moment' // แปลง date

export default {
  components: {
    'left-menu-admin': adminLeftMenu,
    VuetifyMoney,
    QrcodeVue
    // QrcodeStream
    // downloadExcel: JsonExcel,
    // XLSX,
    // readXlsxFile
  },
  created () {
    // setInterval(this.getNowGlobal, 1000)
  },
  data () {
    return {
      PK: '',
      path: '/ReportQRCode/', // Path Model
      // Menu Config
      breadcrumbs: [
        {
          text: 'Home',
          disabled: false,
          href: '/Core/Home'
        },
        {
          text: 'สถิติการได้ coin',
          disabled: false,
          href: '/Tool/ReportCoin'
        }
      ],

      panel: [0],
      panel1: [1],
      session: this.$session.getAll(),

      // Data Table Config
      tab: null,
      columns1: [
        { text: 'Date', value: 'dateUse' },
        { text: 'Branch', value: 'branchName' },
        { text: 'Service', value: 'exName' },
        { text: 'Member Count', value: 'memberCount' },
        { text: 'Coin Count', value: 'sumPoint' }
        // { text: "วันที่อัพเดท", value: "LAST_DATE" }
      ],
      dataItem1: []
      // End Data Table Config
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  async mounted () {
    // this.getDataBranch()
    // this.getProductExchangeRate()
    this.dataReady = false
    // Get Data
    await this.getDataItem1(
      this.DNS_IP
    )
    // this.getDataGlobal(this.DNS_IP, this.path, this.session.data.shopId + '&status=waiting')
    // console.log('xxxx', this.dataItem)
  },
  methods: {
    async getDataItem1 (DNS_IP) {
      // Clear Data ทุกครั้ง
      this.dataItem1 = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          DNS_IP + "/ReportQRCode/getSum",
          {
            headers: {
              'Application-Key': this.$session.getAll().ApplicationKey
            }
          }
        )
        .then(async response => {
          // var dateObj = new Date(response.data.CREATE_DATE)
          // var momentObj = moment(dateObj)
          // response.data.CREATE_DATE = momentObj.format('YYYY-MM-DD')
          console.log('getData1', response.data)
          this.dataReady = true
          this.dataItem1 = response.data
          if (this.dataItem1.length === 0 || this.dataItem1.status === false) {
            this.dataItem1 = []
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch(error => {
          console.log(error)
          this.$swal('ผิดพลาด', 'ไม่มีข้อมูล', 'error')
          this.dataReady = true
        })
    }
  }
}
</script>
<style scoped>
.shopname {
  font-size: 13px;
}
.description {
  font-size: 14px;
}
.summary {
  font-size: 18px;
}
.point {
  font-size: 30px;
  font-weight: bold;
}
.fullscreen {
  position: fixed;
  z-index: 1000;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
}
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);
  /* margin: auto auto;
    display: block; */
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  /* vertical-align: middle; */
}
#margin {
  margin-top: 30px;
  margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tool/ReportCoin.vue